import { createRouter, createWebHistory } from 'vue-router';
import { getAuth } from 'firebase/auth';

// Import your components
import HomePage from '../components/HomePage.vue';
import JournalPage from '../components/JournalPage.vue';
import ArchivePage from '../components/ArchivePage.vue';
import AccountPage from '../components/AccountPage.vue';
import UserLogin from '../components/UserLogin.vue';  // Ensure this is imported if used
import UserSignup from '../components/UserSignup.vue';  // Ensure this is imported if used

const routes = [
    { path: '/', name: 'Home', component: HomePage, meta: { requiresAuth: false } },  // Public access
    { path: '/journal', name: 'Journal', component: JournalPage, meta: { requiresAuth: true } },
    { path: '/archive', name: 'Archive', component: ArchivePage, meta: { requiresAuth: true } },
    { path: '/account', name: 'Account', component: AccountPage, meta: { requiresAuth: true } },
    { path: '/login', name: 'Login', component: UserLogin, meta: { requiresAuth: false } },
    { path: '/signup', name: 'Signup', component: UserSignup, meta: { requiresAuth: false } }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach((to, from, next) => {
    const auth = getAuth();
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const isAuthenticated = auth.currentUser;

    if (requiresAuth && !isAuthenticated) {
        next('/login');
    } else {
        next();
    }
});

export default router;
